import { NewsModel } from '@/models';
import { auth } from '@/services';
import { newsPolicy } from '@/policies';

(function (angular) {
    'use strict';

    angular.module('app')
        .controller('newsController', newsController);

    newsController.$inject = [
        'newsDump',
        'NewsApi',
        'News',
        '$location',
        '$scope',
        'Helpers',
        'PostsSearchApi',
    ];

    function newsController(
        newsDump,
        NewsApi,
        News,
        $location,
        $scope,
        Helpers,
        PostsSearchApi,

    ) {
        const vm = this;
        const nowISO = window.moment().format(Helpers.isoFormat);

        // properties
        vm.permissionChecks = {
            canCreate: newsPolicy.canCreate(auth.user()),
        };
        vm.categories = [].concat($location.search()['categories[]'] || []).map(id => parseInt(id));
        vm.filters = {
            "categories[]": vm.categories,
            page: 1,
            page_size: 12,
            starts_at_from: nowISO,
            status: NewsModel.STATUS_APPROVED,
            search: '',
        };
        vm.orderFilters = {
            ascending: {
                label: 'Ascending',
                sort: 'starts_at',
                order: 'asc',
                starts_at_from: nowISO,
                ends_at_from: null,
            },
            descending: {
                label: 'Descending',
                sort: 'starts_at',
                order: 'desc',
                starts_at_from: nowISO,
                ends_at_from: null,
            },
        };
        vm.selectedOrderFilter = vm.orderFilters.ascending;

        vm.news = [];

        // methods
        vm.searchNews = searchNews;
        vm.createNews = createNews;
        vm.orderNews = orderNews;
        vm.getNews = getNews;
        vm.loadMore = loadMore;
        vm.onCategoryChange = onCategoryChange;
       /**
         * Called when categories have changed.
         * @param categories
         */
        function onCategoryChange(categories: string[]): void {
            vm.categories = categories;
            vm.filters["categories[]"] = categories;

            vm.getNews();
        }

        function searchNews(): void {
            // No need to trouble Solr if we have no search string.
            if (!this.filters.search || this.filters.search === '') {
                vm.getNews();
                return;
            }

            this.isLoading = true;

            PostsSearchApi
                .get(
                    { q: this.filters.search, type: 'news' },
                    (response: any) => {
                        this.news.data = response.results;
                        this.isLoading = false;
                    },
                    () => this.isLoading = false,
                );
        }



             /**
         * Updates filters and refreshes the events.
         * Called by the order events select control.
         *
         * @return {void}
         */
        function orderNews() {
            angular.merge(vm.filters, vm.selectedOrderFilter);
            vm.filters.label = null;
            getNews();
        }

        /**
         * Shows the create news post modal
         * @return {void}
         */
        function createNews() {
            News.manageNews().result.then(function (response) {
                if (response.status === NewsModel.STATUS_APPROVED) {
                    vm.news.data.unshift(response);
                }
            });
        }

        /**
         * Get and display news stories.
         * @return {void}
         */
        function getNews() {
            vm.isLoading = true;
            NewsApi.get(vm.filters, function (response) {
                vm.news.data = [];
                angular.forEach(response.data, function (item) {
                    vm.news.data.push(item);
                    vm.isLoading = false;
                }, function () {
                    vm.isLoading = false;
                });
            });
        }


        function init() {
            vm.isLoading = true;
            var urlParams = $location.search();
            if (Object.keys(urlParams).length) {
                if (urlParams.page) {
                    urlParams.page = parseFloat(urlParams.page);
                }

                angular.extend(vm.filters, urlParams);
                getNews();
            } else {
                vm.news = angular.copy(newsDump);
                vm.news.data = [];

                // Convert each item from the DOM dump to a resource model
                angular.forEach(newsDump.data, function (item) {
                    vm.news.data.push(new NewsApi(item).transform());
                });

                vm.isLoading = false;
            }
        }

        /**
         * Load more news
         * @return {void}
         */
        function loadMore() {
            vm.filters.page_size += 12;
            vm.getNews();
        }

        init();
    }

}(angular));
